import React from "react";
import Card from "components/card";
import { MdGpsFixed, MdSignalCellularAlt, MdEvent, MdAccessTime } from "react-icons/md";

const StatusBanner = ({ currentData }) => {
  // Prevent rendering if playback data hasn't loaded yet
  if (!currentData) return null;

  // Destructure the live data points from the SQL diet query
  const postype = currentData.postype || "UNKNOWN";
  const isGPS = postype === "GPS";
  const motstat = currentData.motstat || "N/A";
  const isMoving = motstat.toUpperCase() === "MOVING";
  const timestamp = currentData.timestamp || "--:--";
  const event = currentData.event || "Normal";

  return (
    <div className="grid grid-cols-1 gap-5 md:grid-cols-4">
      {/* 1. Position Source */}
      <Card extra="flex flex-row items-center p-4">
        <div className={`rounded-full p-2 ${isGPS ? "bg-green-100 text-green-600" : "bg-orange-100 text-orange-600"}`}>
          {isGPS ? <MdGpsFixed size={24} /> : <MdSignalCellularAlt size={24} />}
        </div>
        <div className="ml-3">
          <p className="text-xs font-medium text-gray-600">Position Source</p>
          <h5 className="text-sm font-bold text-navy-700 dark:text-white">
            {postype}
          </h5>
        </div>
      </Card>

      {/* 2. Motion Status */}
      <Card extra="flex flex-row items-center p-4">
        <div className={`rounded-full p-2 ${isMoving ? "bg-blue-100 text-blue-600" : "bg-red-100 text-red-600"}`}>
            {/* The dot pulses when the vehicle is moving! */}
          <div className={`h-3 w-3 rounded-full ${isMoving ? "bg-blue-600 animate-pulse" : "bg-red-600"}`} />
        </div>
        <div className="ml-3">
          <p className="text-xs font-medium text-gray-600">Motion</p>
          <h5 className="text-sm font-bold text-navy-700 dark:text-white uppercase">
            {motstat}
          </h5>
        </div>
      </Card>

      {/* 3. Event Indicator */}
      <Card extra={`flex flex-row items-center p-4 ${event !== "Normal" && event !== "" ? "bg-yellow-50 border border-yellow-200" : ""}`}>
        <div className={`rounded-full p-2 ${event !== "Normal" && event !== "" ? "bg-yellow-500 text-white animate-bounce" : "bg-gray-100 text-gray-400"}`}>
          <MdEvent size={24} />
        </div>
        <div className="ml-3">
          <p className="text-xs font-medium text-gray-600">Latest Event</p>
          <h5 className={`text-sm font-bold ${event !== "Normal" && event !== "" ? "text-yellow-600" : "text-navy-700 dark:text-white"}`}>
            {event}
          </h5>
        </div>
      </Card>

      {/* 4. Live Timestamp */}
      <Card extra="flex flex-row items-center p-4">
        <div className="rounded-full bg-indigo-100 p-2 text-indigo-600">
          <MdAccessTime size={24} />
        </div>
        <div className="ml-3">
          <p className="text-xs font-medium text-gray-600">Live Timestamp</p>
          <h5 className="text-sm font-bold text-navy-700 dark:text-white">
            {timestamp}
          </h5>
        </div>
      </Card>
    </div>
  );
};

export default React.memo(StatusBanner);